module.exports = __webpack_public_path__ + "media/printed-materials/image025-c13340b2.jpg";